import React from "react";
import PropTypes from "prop-types";
import * as msal from "@azure/msal-browser";
// import { ReCaptcha } from "react-recaptcha-v3";
import cx from "classnames";
import { Form, Button } from "antd";
import {
    formHasErrors,
    getErrorOnField,
    submitForm,
    fieldGenerator
} from "utilities/form";
import { AUTH_FORM_FIELDS } from "constants";
import _lower from "lodash/toLower";
import "styles/form.css";
import Microsoft_logo from "assets/microsoft.png";

const createFormField = Form.createFormField;
const FormItem = Form.Item;
const msalConfig = {
    auth: {
        clientId: process.env.CLIENT_ID,
        authority: "https://login.microsoftonline.com/ebda27e9-560f-48c1-bf94-2119f83863d6",
        redirectUri: "https://soul.progfin.com/auth",
    },
};
const msalInstance = new msal.PublicClientApplication(msalConfig);
class AuthForm extends React.Component {
   state = {
        msLoginInProgress: false,
        showPasswordForm: false,
    };

    hasErrors = formHasErrors.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, (values) => {
        if(!values.username.includes("@progfin.com") && !values.username.includes("@progcap.com") && !values.username.includes("@progfin.in") && !values.username.includes("@dispostable")) {
            this.props.askBankUser(values.username);
            return;
        }
        const { props } = this;
        window.grecaptcha.ready(function() {
            return window.grecaptcha.execute(process.env.RECAPTCHA_SITE_KEY, {action : "submit"}).then((token) => {
                props.submitValues({...values, username: _lower(values.username), recaptchaToken: token});
                return token;
            }).catch(() => {
                // console.error(err);
            });
        });
    }
    );
  loginWithMicrosoft = async () => {
    this.setState({ msLoginInProgress: true });
    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });
      const microsoftAuthResponse = {
        access_token: loginResponse.accessToken,
        id_token: loginResponse.idToken,
        token_type: loginResponse.tokenType,
      };
      const recaptchaToken = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(process.env.RECAPTCHA_SITE_KEY, { action: "login" })
            .then(resolve)
            .catch(reject);
        });
      });
    this.props.submitValues({ username: "", password: "", recaptchaToken, microsoftAuthResponse,});
    this.setState({ msLoginInProgress: false })
  } 
  catch (err) {
    console.error(err);
    this.setState({ msLoginInProgress: false });
  }  
  };
    fieldGenerator = fieldGenerator.bind(this.props.form);
    
    render() {
        const { showPasswordForm } = this.state;
        return (
            <Form
                onSubmit={this.handleFormSubmit}
                className={cx("form", "br-3")}
            >
                {showPasswordForm && (
                    <React.Fragment>
                        {AUTH_FORM_FIELDS.map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                            .toList()
                            .toJS()}
                        <FormItem>
                            <Button type="primary"
                                className={"g-recaptcha"}
                                block
                                htmlType="submit"
                                loading={this.props.formSubmitting && !this.state.msLoginInProgress}
                            >
                                Login
                            </Button>
                            <div style={{ textAlign: "right", marginTop: "6px" }}>
                                <Button
                                    type={"link"}
                                    onClick={this.props.onForgotPassword}
                                    style={{ padding: 0, fontSize: "13px" }}
                                >
                                    Forgot Password?
                                </Button>
                            </div>
                        </FormItem>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "8px 0",
                            fontSize: "14px",
                            color: "#888",
                        }}>
                            <div style={{ flex: 1, height: "1px", backgroundColor: "#eee" }} />
                            <span style={{ padding: "0 10px" }}>OR</span>
                            <div style={{ flex: 1, height: "1px", backgroundColor: "#eee" }} />
                        </div>
                    </React.Fragment>
                )}

                <FormItem>
                    <Button
                        className={"g-recaptcha"}
                        block
                        onClick={this.loginWithMicrosoft}
                        loading={this.state.msLoginInProgress}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            height: "44px",
                            padding: "0 16px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            fontSize: "15px",
                            fontWeight: 500,
                            color: "#333",
                            backgroundColor: "#fff",
                            cursor: "pointer",
                            width: "100%",
                        }}
                    >
                        <img
                            src={Microsoft_logo}
                            alt="Microsoft Logo"
                            width={20}
                            height={20}
                            style={{ display: "inline-block", flexShrink: 0 }}
                        />
                        Login with Microsoft
                    </Button>
                </FormItem>

                {!showPasswordForm && (
                    <div style={{ textAlign: "center", marginTop: "4px" }}>
                        <Button
                            type="link"
                            onClick={() => this.setState({ showPasswordForm: true })}
                            style={{ fontSize: "13px", color: "#888" }}
                        >
                            Having trouble? Login with credentials
                        </Button>
                    </div>
                )}
            </Form>
        );
    }
}

AuthForm.defaultProps = {
    formSubmitting: false
};

AuthForm.propTypes = {
    id: PropTypes.string,
    values: PropTypes.object,
    errors: PropTypes.object,
    form: PropTypes.object,
    formSubmit: PropTypes.func,
    formSubmitting: PropTypes.bool,
    submitValues: PropTypes.func,
    askBankUser: PropTypes.func,
    onForgotPassword: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values, errors }) => {
        if (values && values.size) {
            return values
                .map((_, fieldName) =>
                    createFormField({
                        value: _,
                        errors: errors && errors.get(fieldName)
                    })
                )
                .toJS();
        }
    }
})(AuthForm);
